"use client";

import { useState, useTransition } from "react";
import { useRouter } from "next/navigation";
import { UserRoundX } from "lucide-react";
import { blockSocialMomentAuthor, setUserBlocked } from "@/app/actions/contact-blocks";
import { contactBlockingEnabled } from "@/lib/safety/contact-blocks";

export function BlockUserButton({ userId, moment, displayName, onBlocked }: ({ userId: string; moment?: never } | { userId?: never; moment: { id: string; squadId: string } }) & {
  displayName: string;
  onBlocked?: (userId: string) => void;
}) {
  const router = useRouter();
  const [pending, startTransition] = useTransition();
  const [confirming, setConfirming] = useState(false);
  const [error, setError] = useState("");
  if (!contactBlockingEnabled()) return null;
  return (
    <span className="inline-flex flex-col items-start gap-1">
      <button type="button" disabled={pending} onClick={() => setConfirming(!confirming)}
        aria-expanded={confirming} aria-label={`Block ${displayName}`}
        className="inline-flex min-h-11 items-center gap-1.5 rounded-sm px-2 text-xs text-text-muted hover:text-error disabled:opacity-50">
        <UserRoundX size={15} aria-hidden="true" /> Block
      </button>
      {confirming && <span className="block max-w-sm rounded-sm border border-border bg-white p-3 text-left text-xs leading-relaxed text-navy">
        Block {displayName}? Their posts and shared location will be hidden when you are signed in, and further contact will be restricted. You can unblock them in Settings.
        <span className="mt-2 flex flex-wrap gap-2">
          <button type="button" disabled={pending} className="min-h-11 rounded-sm bg-navy px-3 font-semibold text-white disabled:opacity-50"
            onClick={() => startTransition(async () => {
              setError("");
              const result = userId
                ? { ...await setUserBlocked(userId, true), userId }
                : await blockSocialMomentAuthor(moment!.id, moment!.squadId);
              if (result.error) { setError(result.error); return; }
              setConfirming(false);
              if (result.userId) onBlocked?.(result.userId);
              router.refresh();
            })}>{pending ? "Blocking…" : "Block account"}</button>
          <button type="button" className="min-h-11 px-3" disabled={pending} onClick={() => setConfirming(false)}>Cancel</button>
        </span>
      </span>}
      {error && <span role="alert" className="block text-xs text-error">{error}</span>}
    </span>
  );
}
